import { render } from "./BusinessRegisterPage.vue?vue&type=template&id=676e63f7&scoped=true"
import script from "./BusinessRegisterPage.vue?vue&type=script&lang=js"
export * from "./BusinessRegisterPage.vue?vue&type=script&lang=js"

import "./BusinessRegisterPage.vue?vue&type=style&index=0&id=676e63f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676e63f7"]])

export default __exports__